<template>
  <div>
    <div
      id="div-results-lhs"
      v-bind:style="showResultsSection
        ? { right: resultsContainerWidth-12 + 'px' }
        : { right: '66px'}"
    >
      <span
        slot="activator"
        @click="handleToggleResultsClick"
        class="action-btn action-btn-close-results"
      >
        <v-icon v-if="showResultsSection" id="action-btn-close-results-icon">chevron_right</v-icon>
        <v-icon v-else class="action-btn-close-results-icon">chevron_left</v-icon>
      </span>
      <span v-if="showingLhsDragging" v-on:mousedown.stop.prevent="$emit('update:lhsDragging', true)">
        <v-icon id="div-results-lhs-drag-icon">more_vert</v-icon>
      </span>
    </div>
    <v-slide-x-reverse-transition hide-on-leave="true">
      <div
        id="div-results"
        v-show="showResultsSection"
        v-bind:style="{width: resultsContainerWidth-70 + 'px'}"
      >
        <results-iframe
          :showingAITab="showResultsComponent"
          :targetEngine="targetEngine"
          :lhsDragging="lhsDragging"
          @newTabResults="$emit('newTabResults')"
          @reloadResults="$emit('reloadResults')"
          @handleCopyClick="$emit('handleCopyClick', $event)"
          @launchGeneratorQuery="$emit('launchGeneratorQuery', $event)"
          @handleGenerateSearchStrategy="$emit('handleGenerateSearchStrategy')"
        ></results-iframe>
      </div>
    </v-slide-x-reverse-transition>
    <v-layout flex column id="results-section-container">
      <source-carousel
        @handleTargetEngineClick="$emit('handleTargetEngineClick', $event)"
      ></source-carousel>
    </v-layout>
  </div>
</template>
<script>
import SourceCarousel from './SourceCarousel'
import ResultsIframe from './ResultsIframe'

import '../../../style/_variables.scss'

export default {
  name: 'ResultsSection',
  components: {SourceCarousel, ResultsIframe},
  props: ['targetEngine', 'lhsDragging'],
  data () {
    return {
      showingLhsDragging: true
    }
  },
  computed: {
    showResultsSection: { get () { return this.$store.state.appState.showResultsSection } },
    showResultsComponent: { get () { return this.$store.state.appState.showResultsComponent } },
    resultsContainerWidth: { get () { return this.$store.state.appState.resultsContainerWidth } },
    showAIComponent: { get () { return this.$store.state.appState.showAIComponent } }
  },
  methods: {
    handleToggleResultsClick () {
      this.showingLhsDragging = !this.showingLhsDragging
      this.$emit('toggleResults')
    },
    handleDraggingEvent () {
      this.$store.commit('setResultsContainerWidth', true)
    }
  }
}
</script>

<style lang="scss">
#results-section-container {
  position: absolute;
  top: $main-header-height;
  right: 0;
  z-index: 90;
  width: $side-nav-width;
  height: calc(100% - #{$main-header-height});
  background-color: $bg-primary;
  //border-left: 10px solid $grey-400;
}

#div-results {
  position: absolute;
  display: flex;
  flex-direction: column;
  z-index: 90;
  top: $main-header-height;
  right: $side-nav-width;
  min-width: $length-xlarge-xl;
  max-width: calc(100vw - #{$side-nav-width} - #{$side-nav-width});
  height: calc(100% - #{$main-header-height});
  margin-left: $length-small-xl;
  border-left: 10px solid $grey-400;
  border-right: 10px solid $grey-400;
  background-color: $bg-primary;
  text-align: left;
  &-lhs {
    padding-top: 15vh;
    position: absolute;
    display: flex;
    flex-direction: column;
    width: $length-med-m;
    z-index: 100;
    &-drag-icon {
      color: $grey-500;
      cursor: ew-resize;
      font-size: 36px;
      position: relative;
      left: -6px;
      &:hover {
        color: $blue-primary;
      }
    }
  }
}
.action-btn-close-results {
  box-shadow: 0 0 2px $grey-500;
  position: relative;
  align-self: center;
  background-color: $bg-primary;
  border: unset;
  width: 35px;
  margin-bottom: $length-med-l;
  &:hover {
    border-width: 2.5px;
    border-color: $blue-primary;
  }
}
#action-btn-close-results-icon {
  color: $blue-primary;
}
</style>



// WEBPACK FOOTER //
// src/components/parts/ResultsContainer/ResultsSection.vue